// src/components/student/StudentSidebar.js
import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../assets/css/student/StudentSidebar.css';
import AppContext from '../../../context/AppContext';

const StudentSidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {storeSelectedStudyGroupScreenName,storeLoggedInStudent} = useContext(AppContext);

  const menuItems = [
    {
      section: 'MAIN',
      items: [
        { 
          id: 'dashboard', 
          icon: '📊', 
          label: 'Dashboard', 
          path: '/student-Dashboard',
          description: 'Overview & Analytics'
        },
        { 
          id: 'my-groups', 
          icon: '👥', 
          label: 'My Study Groups', 
          path: '/my-study-group',
          description: 'Active groups'
        },
        { 
          id: 'calendar', 
          icon: '📅', 
          label: 'Study Calendar', 
          path: '/study-calendar',
          description: 'Upcoming sessions'
        }
      ]
    },
    {
      section: 'STUDY TOOLS',
      items: [
        { 
          id: 'whiteboard', 
          icon: '✏️', 
          label: 'White Board', 
          path: '/collaborative-board',
          description: 'Solve problems together'
        },
        { 
          id: 'resources', 
          icon: '📚', 
          label: 'Resources Library', 
          path: '/resources-library',
          description: 'Shared files & notes'
        },
        { 
          id: 'ai-assistant', 
          icon: '🤖', 
          label: 'AI Study Assistant', 
          path: '/ai-study-assistant',
          description: 'Smart help & summaries'
        }
      ]
    },
    {
      section: 'ASSESSMENT',
      items: [
        // { 
        //   id: 'quizzes', 
        //   icon: '📋', 
        //   label: 'Quizzes & Tests', 
        //   path: '/quizzes-and-test',
        //   description: 'Practice & assess'
        // },
        { 
          id: 'flashcards', 
          icon: '🎴', 
          label: 'Flashcards', 
          path: '/flash-cards',
          description: 'Quick revision'
        },
        // { 
        //   id: 'progress', 
        //   icon: '📈', 
        //   label: 'My Progress', 
        //   path: '/my-progress',
        //   description: 'Track learning'
        // }
      ]
    },
    {
      section: 'SETTINGS',
      items: [
        { 
          id: 'settings', 
          icon: '⚙️', 
          label: 'Student Settings', 
          path: '/student-Settings',
          description: 'Manage your settings'
        },
        { 
          id: 'notifications', 
          icon: '🔔', 
          label: 'Notifications', 
          path: '/notifications',
          description: 'Alerts & updates'
        }
      ]
    }
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      // Clear any stored user data
      localStorage.removeItem('studentEmail');
      localStorage.removeItem('studentPassword');
      // Navigate to login page
      navigate('/login');
    }
  };

  useEffect(()=>{
    const student = localStorage.getItem("loggedInStudent");
    storeLoggedInStudent(JSON.parse(student));
   },[])

  return (
    <>
      {/* Mobile Toggle Button */}
      <button 
        className="sidebar-toggle" 
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        ☰
      </button>

      {/* Mobile Overlay */}
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={toggleSidebar}
      />

      {/* Sidebar */}
      <aside className={`student-sidebar ${!isOpen ? 'closed' : ''} ${isOpen ? 'open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <div className="logo-icon">🎓</div>
          <h3>CircleHub</h3>
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar-menu">
          {menuItems.map((section, sectionIndex) => (
            <div key={sectionIndex} className="menu-section">
              <div className="menu-section-title">{section.section}</div>
              {section.items.map((item) => (
                <div
                  key={item.id}
                  className={`menu-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => {
                    storeSelectedStudyGroupScreenName(item.label)
                    navigate(item.path);
                    if (window.innerWidth <= 768) toggleSidebar();
                  }}
                  title={item.description}
                >
                  <span className="menu-item-icon">{item.icon}</span>
                  <div className="menu-item-content">
                    <span className="menu-item-text">{item.label}</span>
                    {item.description && (
                      <span className="menu-item-description">{item.description}</span>
                    )}
                  </div>
                  {item.badge && (
                    <span className={`menu-item-badge ${item.badge === 'NEW' ? 'badge-new' : ''}`}>
                      {item.badge}
                    </span>
                  )}
                </div>
              ))}
            </div>
          ))}

          {/* Logout Button */}
          <div className="menu-section">
            <div 
              className="menu-item logout-item"
              onClick={handleLogout}
              title="Logout from your account"
            >
              <span className="menu-item-icon">🚪</span>
              <div className="menu-item-content">
                <span className="menu-item-text">Logout</span>
                <span className="menu-item-description">Sign out</span>
              </div>
            </div>
          </div>
        </nav>

        {/* User Profile */}
        <div className="sidebar-profile">
          <div className="profile-info">
            <div className="profile-avatar">S</div>
            <div className="profile-details">
              <div className="profile-name">Student Name</div>
              <div className="profile-role">Computer Science</div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default StudentSidebar;